import React from 'react'
import cx from 'classnames'
import ChevronRight from 'src/assets/images/chevron-right.png'

const GradientTextLink = ({ title, type = 'gradient', className }) => {
  return (
    <div className={cx('flex w-fit items-center gap-1', className)}>
      <span
        className={cx(
          'text-[14px] font-bold uppercase leading-normal tracking-[5px]',
          type === 'gradient'
            ? 'text-blue-gradient'
            : type == 'white'
              ? 'text-[#FFF]'
              : '',
        )}
      >
        {title}
      </span>
      <img
        src={ChevronRight}
        alt='Chevron Right'
        className={cx(
          'h-[14px] w-[14px]',
          type === 'white' ? 'brightness-0 invert' : '',
        )}
      />
    </div>
  )
}

export default GradientTextLink
